module.exports = __webpack_public_path__ + "img/philippines.9124b268.svg";